import { log } from 'console';
import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ActionSheetController, ModalController } from "@ionic/angular";
import { ViewApplicationService } from "src/app/services/view-application.service";
import { ViewPdfComponent } from "../../view-pdf/view-pdf.component";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { Page } from "src/app/model/Page";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DatePipe } from "@angular/common";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import moment from "moment";
import { ApplicantStatusService } from "src/app/services/Applicant-Status.service";
import { AppointmentRejectComponent } from '../reject-case/appointment-reject-case.component';
import { AppointmentApproveComponent } from '../approve-case/appointment-approve-case.component';
import { ForwardAnotherAuthorityComponent } from '../forward-another-authority-case/forward-another-authority-case.component';
import { RescheduledAppointmentComponent } from '../RescheduledAppointment/RescheduledAppointment.component';
import { ApplicantListModel } from 'src/app/services/ApplicantListModel';

@Component({
  selector: "app-secure-view-applicant-appointment-dtl",
  templateUrl: "./applicant-appointment-dtl.component.html",
  styleUrls: ["./applicant-appointment-dtl.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ViewApplicantAppoitmentDtlComponent implements OnInit {

appointmentId: any;
  data: ApplicantListModel;
  data1: ApplicantListModel;

   page: Page<ApplicantListModel>;
  dataSource: MatTableDataSource<ApplicantListModel> =
    new MatTableDataSource();
  applicationNo: number;
  photo: any;
  appealType: string;
  appealDate: string;
  remark: string;
  selectedOfficerKey:any;
  extendDaysValue: string;
  isLoading: boolean = false;
  manualRejectedQuestions: any[] = [];
  documents: ApplicantListModel[] = [];
  verifiedStatus: any[] = [];
  documentName: string = "";
  profileDetails: any[] = [];
  areQuestionsNotAnswered: boolean;
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  newInstmantDate: string;
  progressSpinnerDialog: any = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isSearchDisabled: boolean = false;
  isAllowedForAppeal: boolean = false;
  isAppealApproved: boolean = false;

  appealHearingStatus: boolean = false;
  rejectStatus: boolean = false;
  isappealHearingType: boolean = false;
  appealDateIs: boolean;

  dateColorFormat: Date;
  form: FormGroup = new FormGroup({});
  ApplicantListModel: ApplicantListModel[] = [];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  showtable: number = 5000001;
  source: string;
  editedAppointmentDate: string;
  editedstarttimeChange: string;
  editedendtimeChange: string;
  selectedSlotKey: any;

  tomorrowDate: string;
  otherPersonsList: ApplicantListModel[] = [];

  constructor(
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private router: Router,
    public actionSheetController: ActionSheetController,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private applicantStatusService: ApplicantStatusService

  ) {
    const currentDate = new Date();
    const tomorrow = new Date(currentDate);
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.tomorrowDate = this.datePipe.transform(tomorrow, "yyyy-MM-dd");
  }

  ngOnInit(): void {
   // this.loadData();
    this.loadDetail();
    this.showappointmentdocfile();
    this.form = new FormGroup({
      installmentFormList: new FormArray([]),
    });
  }
isAppointmentExpired(): boolean {

  if (!this.data?.appointment_date || !this.data?.appointmentEndTime) {
    return false;
  }

  // Example:
  // appointment_date = 2026-05-07
  // appointmentEndTime = 11:00 AM

  const appointmentDateTime = moment(
    `${this.data.appointment_date} ${this.data.appointmentEndTime}`,
    "YYYY-MM-DD hh:mm A"
  );

  // Subtract 30 minutes
  appointmentDateTime.subtract(30, 'minutes');

  const currentDateTime = moment();

  console.log("Appointment Block Time:", appointmentDateTime.format("YYYY-MM-DD hh:mm A"));
  console.log("Current Time:", currentDateTime.format("YYYY-MM-DD hh:mm A"));

  return currentDateTime.isAfter(appointmentDateTime);
}
  
  isDateLessThanToday(date: string): boolean {
    // console.log(date, new Date(), new Date(date))
    // console.log(this.convertAndCompare(date));
    return new Date(date) <= new Date();
  }
  

  loadDetail() {
    this.route.params.subscribe((params: Params) => {
      this.appointmentId = +params["appointmentId"];
      console.log("Route Parameters:", params);
      console.log("Appointment ID:", this.appointmentId);
  
      // Fetch appointment details
      this.applicantStatusService.fetchAppointmentDetail(this.appointmentId).subscribe(
        async (data: ApplicantListModel) => {
          console.log("Appointment Data:", data);
  
          // Assign fetched appointment data
          this.editedAppointmentDate = data.appointment_date;
          this.editedstarttimeChange = data.appointmentStratTime;
          this.editedendtimeChange = data.appointmentEndTime;
          this.data = data;
  
          // Fetch and store the list of other persons
          this.fetchOtherPersonsList();
        },
        (error) => {
          console.error("Error fetching appointment details:", error);
        }
      );
    });
  }
  
  // Fetch other persons list
  fetchOtherPersonsList() {
    this.applicantStatusService.fetchOtherPersonList(this.appointmentId).subscribe(
      (response) => {
        if (Array.isArray(response)) {
          console.log("Other Persons List:", response);
          this.otherPersonsList = response; // Store the list in a variable
        } else {
          console.error("Unexpected response format:", response);
        }
      },
      (error) => {
        console.error("Error fetching other persons list:", error);
      }
    );
  }
  
  
  
  
  showappointmentdocfile() {
    this.isLoading = true;
    this.applicantStatusService.fetchAppointDocFiles(this.appointmentId).subscribe( 
      (response) => {
        this.isLoading = false;
        console.log('Response from backend:', response); 
        // if (response.status === "SUCCESS") {
          this.documents = response;
        //  this. documents.forEach(async (document) => {
        //     const modal = await this.modalCtrl.create({
        //       component: ViewPdfComponent,
        //       componentProps: {
        //         base64: document.fileBase64, 
        //         documentName: document.documentName,
        //         fileName: document.documentName + "_" + new Date().getTime() + ".pdf",
        //       },
        //     });
        //     modal.present();
        //   });
        // } else {
        // }
      },
      (error) => {
        this.isLoading = false;
        console.error('Error occurred while fetching documents:', error); 
        // Handle error if needed
      }
    );
    
  }

  dateChange(event: any) {
    this.editedAppointmentDate = event.target.value;
}
starttimeChange(event: any) {
  this.editedstarttimeChange = event.target.value;
}endtimeChange(event: any) {
  this.editedendtimeChange = event.target.value;
}
  showDocument(document: any) {
    this.modalCtrl.create({
      component: ViewPdfComponent,
      componentProps: {
        base64: document.fileBase64, 
        documentName: document.documentName,
        fileName: document.documentName + "_" + new Date().getTime() + ".pdf",
      }
    }).then(modal => modal.present());
  }
  
  
  async approve() {
    const modal = await this.modalCtrl.create({
      component: AppointmentApproveComponent,
      componentProps: {
      appointmentId: this.appointmentId.toString(),
    },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "approve") {
      console.log("DATA", data);
      this.remark=data.approvedRemark,
      this.applicantStatusService
        .approveAppointment(
          this.appointmentId,
          data,
        )
        .subscribe((data) => {
          console.log(data, "fromStatus files API");
          // After successful approval and data submission, navigate to the appointment list component
          this.router.navigate(['/secure/apointmentList']);
          this._snackBar.open("Appointment Request Accepted", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });
        });
    }
}
  async reject() {
    const modal = await this.modalCtrl.create({
      component: AppointmentRejectComponent,
      componentProps: {
        appointmentId:this.appointmentId,
        remark:this.remark,

      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "reject") {
      console.log("DATA", data);
      this.applicantStatusService
        .rejectedAppointment(
          this.appointmentId,
          data,
          "REJECTED"
        )
        .subscribe((data) => {
          console.log(data, "fromStatus files API");
         // this.loadData();
         this.router.navigate(['/secure/apointmentList']);
          this._snackBar.open("Appointment Request REJECTED", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "danger-toast",
            duration: 3 * 1000,
          });
        });
    }
  }
  async forward() {
    const modal = await this.modalCtrl.create({
      component: ForwardAnotherAuthorityComponent,
      componentProps: {
        appointmentId:this.appointmentId,
        remark:this.remark,
        selectedOfficerKey: this.selectedOfficerKey


      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === "forward") {
      this.selectedOfficerKey=data.selectedOfficerKey,
      this.selectedSlotKey=data.selectedSlotKey,
      this.remark=data.forwardReason,

      console.log("DATA", data);
      console.log("selectedOfficerKey", this.selectedOfficerKey);
      console.log("DATA", this.remark);

      this.applicantStatusService
        .forwardAppointment(
          this.appointmentId,
          this.selectedOfficerKey,
          this.selectedSlotKey,
          data.forwardReason,
        )
        .subscribe((data) => {
          console.log(data, "fromStatus files API");
         // this.loadData();
         this.router.navigate(['/secure/apointmentList']);
          this._snackBar.open("Appointment Forwarded SuccessFully", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "danger-toast",
            duration: 3 * 1000,
          });
        });
      }
  }
  async Rescheduled() {
    const modal = await this.modalCtrl.create({
      component: RescheduledAppointmentComponent,
      componentProps: {
        appointmentId:this.appointmentId,
        remark:this.remark,
        selectedOfficerKey: this.selectedOfficerKey


      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === "Reschedule") {
      this.selectedSlotKey=data.selectedSlotKey,
      this.remark=data.forwardReason,

      console.log("DATA", data);
      console.log("DATA", this.remark);

      this.applicantStatusService
        .RescheduleAppointment(
          this.appointmentId,
          this.selectedSlotKey,
         this.remark= data.forwardReason,
        )
        .subscribe((data) => {
          console.log(data, "fromStatus files API");
         // this.loadData();
         this.router.navigate(['/secure/apointmentList']);
          this._snackBar.open("Appointment Rescheduled SuccessFully", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });
        });
      }
  }
 
  
  newExtendedDate(oldDate, extendDays) {
    if (oldDate && extendDays) {
      return moment(oldDate, "DD/MM/YYYY HH:mm:ss")
        .add(extendDays, "days")
        .format("DD/MM/YYYY HH:mm:ss");
    } else return null;
  }
  newInstPaymentInterestRateCal(oldInsRate, newInsRate) {
    // console.log('newInstPaymentInterestRateCal call', oldInsRate, newInsRate);
    // console.log(typeof (oldInsRate), typeof (newInsRate));
    if (+newInsRate) {
      console.log("Inner Method Call");
      return +oldInsRate + Number(newInsRate);
    } else return null;
  }

  

  get installmentList() {
    return this.form.get("installmentFormList")["controls"];
  }
  
}
